<template>
  <tr>
    <!-- Trip Leg ID/Index -->
    <td class="tw-whitespace-nowrap tw-w-7 tw-px-2 tw-py-2 tw-text-slate-700">+</td>

    <!-- Trip Type -->
    <td class="tw-px-1 tw-py-2 tw-w-32">
      <FilterableDropdown
        autofocus
        placeholder="Trip Type"
        v-model="editingTrip.type"
        :options="tripTypes"
        :clearable="false"
        :searchable="true"
        size="sm"
      />
    </td>

    <!-- Scheduled Date -->
    <td class="tw-px-1 tw-py-2 tw-w-32 dispatch-trip-edit-scheduled-date">
      <DatePicker
        class="tw-block"
        :input-class="'tw-rounded-lg tw-border tw-border-slate-200 tw-bg-white tw-px-2 tw-py-1.5 tw-text-sm focus:tw-outline-none focus:tw-ring-4 focus:tw-ring-indigo-500/15 focus:tw-border-indigo-500/55'"
        format="MM/DD/YYYY"
        v-model="editingTrip.scheduledDate"
        :show-days-shortcuts="true"
        controls-placement="popup"
      ></DatePicker>
    </td>

    <!-- Origin -->
    <td class="tw-px-1 tw-py-2 tw-w-56">
      <FilterableDropdown
        placeholder="Origin"
        v-model="editingTrip.origin"
        :customLabel="(x) => (x.shortName ? x.shortName : x.name)"
        :options="(originCustomers || []).concat(terminals || [])"
        :clearable="false"
        :searchable="true"
        size="sm"
        @search-change="onOriginCustomerSearch"
      />
    </td>

    <!-- Destination -->
    <td class="tw-px-1 tw-py-2 tw-w-56">
      <FilterableDropdown
        placeholder="Destination"
        v-model="editingTrip.destination"
        :customLabel="(x) => (x.shortName ? x.shortName : x.name)"
        :options="(destinationCustomers || []).concat(terminals || [])"
        :clearable="false"
        :searchable="true"
        size="sm"
        @search-change="onDestinationCustomerSearch"
      />
    </td>

    <!-- Driver -->
    <td class="tw-px-1 tw-py-2 tw-w-56">
      <FilterableDropdown
        placeholder="Driver"
        v-model="editingTrip.driver"
        label="fullName"
        :options="filterDrivers"
        :clearable="true"
        :searchable="true"
        size="sm"
      />
    </td>

    <!-- Chassis -->
    <td class="tw-px-1 tw-py-2 tw-w-36">
      <input
        type="text"
        class="tw-w-full tw-rounded-lg tw-border tw-border-slate-200 tw-bg-white tw-px-2 tw-py-1.5 tw-text-sm focus:tw-outline-none focus:tw-ring-4 focus:tw-ring-indigo-500/15 focus:tw-border-indigo-500/55"
        placeholder="Chassis Number"
        v-model="editingTrip.chassis"
      />
    </td>

    <!-- Actions -->
    <td class="tw-whitespace-nowrap tw-px-0 tw-py-2">
      <div class="tw-flex tw-justify-end tw-items-center tw-gap-1">
        <Button
          :isGreen="true"
          @click="confirmAddTrip"
          class="tw-h-9 tw-w-9 tw-p-0"
          icon="check"
          title="Confirm add trip"
          aria-label="Confirm add trip"
        />
        <Button
          :isRed="true"
          :isSecondary="true"
          @click="cancelTripAddition"
          class="tw-ml-1 tw-h-9 tw-w-9 tw-p-0"
          icon="xmark"
          title="Cancel add trip"
          aria-label="Cancel add trip"
        />
      </div>
    </td>
  </tr>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

import DatePicker from '@/components/core/DateTime/DatePicker.vue';

import FilterableDropdown from '../../core/FilterableDropdown.vue';
import Button from '../../core/Button.vue';
import { TripTypesList } from '../../../lib/trips';

export default defineComponent({
  components: {
    FilterableDropdown,
    Button,
    DatePicker,
  },
  data() {
    return {
      tripTypes: TripTypesList,
    };
  },
  props: {
    editingTrip: Object,
    filteredChassis: Array,
    filterDrivers: Array,
    destinationCustomers: Array,
    terminals: Array,
    originCustomers: Array,
  },
  methods: {
    confirmAddTrip() {
      (this as any).$emit('confirmAddTrip');
    },
    cancelTripAddition() {
      (this as any).$emit('cancelTripAddition');
    },
    addChassisTag(props, editingTrip) {
      (this as any).$emit('addChassisTag', props, editingTrip);
    },
    onOriginCustomerSearch(customerName: string) {
      (this as any).$emit('onOriginCustomerSearch', customerName);
    },
    onDestinationCustomerSearch(customerName: string) {
      (this as any).$emit('onDestinationCustomerSearch', customerName);
    },
  },
});
</script>

<style scoped>
table td {
  vertical-align: middle;
}
.dispatch-trip-edit-scheduled-date :deep(.mx-datepicker) {
  width: 100% !important;
}
.dispatch-trip-edit-scheduled-date :deep(.mx-datepicker) input {
  padding: .5rem !important;
}
</style>
